import * as authText from "../../../ui/components/Auth/authTypography.style.css";

const linkStyle = {
  fontSize: 12,
  marginTop: 8,
  display: "inline-block",
};

export function DevEmailCaptureLink() {
  if (!import.meta.env.DEV) return null;
  return (
    <a
      href="/captured-emails"
      target="_blank"
      rel="noopener noreferrer"
      className={authText.link}
      style={linkStyle}
    >
      View local email captures
    </a>
  );
}

export function DevSmsCaptureLink() {
  if (!import.meta.env.DEV) return null;
  return (
    <a
      href="/captured-sms"
      target="_blank"
      rel="noopener noreferrer"
      className={authText.link}
      style={linkStyle}
    >
      View local SMS captures
    </a>
  );
}
